import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";
import { defineState } from 'redux-localstore';

const defaultState = {
  category: [],
  error: false,
  loading: false,
  lastSync: false
};

const initialState = defineState(defaultState)('category');

const fetchStart = (state) => {
  return updateObject(state, { error: false, loading: true, lastSync: false });
};

const fetchSuccess = (state, action) => {
  const result = action.category.length > 0 ? action.category : [];
  return updateObject(state, {
    category: result,
    error: false,
    loading: false,
    lastSync: new Date()
  });
};

const fetchFail = (state) => {
  return updateObject(state, { error: true, loading: false, lastSync: false, category: [] });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_CATEGORY_START:
      return fetchStart(state);
    case actionTypes.FETCH_CATEGORY_SUCCESS:
      return fetchSuccess(state, action);
    case actionTypes.FETCH_CATEGORY_FAILED:
      return fetchFail(state);
    default:
      return {
        ...state,
        error: true,
        loading: false
      };
  }
};

export default reducer;
